import React, { Component } from 'react';
import '../style/contact.css';
import { imageLocation } from '../config/constants';
import Map from '../google/Map';

export class Contact extends Component {
	state = {
		hoverIndex: null
	};

	componentWillMount() {
		document.title = 'Contact';
	}

	render() {
		return (
			<div className="contact">
				<div style={{ position: 'absolute', width: '20vw' }}>
					<Map width="20vw" height="calc(100vh - 100px)" />
				</div>
				<div style={{ marginLeft: '20vw' }}>
					{this.props.data.staff.map((person, idx) => (
						<a
							key={'person' + idx}
							className="person"
							onMouseEnter={() => this.setState({ hoverIndex: idx })}
							onMouseLeave={() => this.setState({ hoverIndex: null })}
						>
							<div
								className="image"
								style={{
									backgroundImage: `url(${imageLocation}staff/${person.name.replace(/ /g, '%20')}.jpg)`
								}}
							>
								<div
									className="image"
									style={{
										height: '100%',
										opacity: this.state.hoverIndex === idx ? 1 : 0,
										backgroundImage:
											`url(${imageLocation}staff/${person.name.replace(/ /g, '%20')}2.jpg`
									}}
								/>
							</div>
							<p> {person.name} </p>
							<p> {person.title} </p>
							<p> {person.email} </p>
						</a>
					))}
				</div>
			</div>
		);
	}
}

export class MobileContact extends Contact {
	render() {
		return (
			<div className="mobileContact">
				<div style={{ height: 'calc(31vh)', width: '100%' }}>
					<div style={{ position: 'absolute', height: 'calc(55vh)', width: '100%' }}>
						<Map width="100%" height="30vh" />
					</div>
				</div>
				{this.props.data.staff.sort((a, b) => a.name > b.name).map((person, idx) => (
					<div key={'person' + idx} className="person">
						<div
							ref={(ref) => (this.ref = ref)}
							className="image"
							style={{
								backgroundImage: `url(${imageLocation}staff/${person.name.replace(/ /g, '%20')}.jpg)`
							}}
						/>
						<p> {person.name} </p>
						<p> {person.title} </p>
						<p> {person.email} </p>
					</div>
				))}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/contact.js